export { default } from './BancoDoAutoMotoBannerRCF';
